import { createSlice } from "@reduxjs/toolkit";
import { pressMediaAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const pressMediaSlice = createSlice({
  name: "pressMedia",
  initialState: data,
  reducers: {
    pressMediaSlice(state) {
      state.isLoading = false;
    },
    pressMediaSliceSuccess(state, action) {
      state.isLoading = true;
      state.data = action.payload;
      state.message = null;
    },
    pressMediaSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    pressMediaSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const pressMediaHandler = () => async (dispatch: any) => {
  try {
    dispatch(pressMediaAction.pressMediaSlice());
    const response: any = await pressMediaAPI();
    dispatch(pressMediaAction.pressMediaSliceSuccess(response));
  } catch (e: any) {
    dispatch(pressMediaAction.pressMediaSliceFailure(e?.response?.data?.message));
    dispatch(pressMediaAction.pressMediaSliceReset());
  }
};
export default pressMediaSlice.reducer;
export const pressMediaAction = pressMediaSlice.actions;
